import { get } from "@ember/object"
import Component from "@glimmer/component"
import type { GoogleClassroomClassSetting } from "@shared/models/card-stack"
import type { GoogleClass } from "@shared/models/google-classroom"
import { find, isNil } from "lodash-es"
interface Signature {
  Args: {
    classSettings: Array<GoogleClassroomClassSetting>
    googleClass: GoogleClass
  }
  Blocks: {
    default: [GoogleClassroomClassSetting]
  }
}

export default class GoogleClassroomFindClassSetting extends Component<Signature> {
  get classSetting() {
    let existingClassSetting = find(
      this.args.classSettings,
      (setting) => get(setting, "googleClassId") === get(this.args.googleClass, "id")
    )

    if (isNil(existingClassSetting)) {
      return {
        googleClassId: this.args.googleClass.id,
        isEnabled: false,
        scheduledAtTime: {
          hour: 6,
          minute: 0,
        },
        dueAt: {
          date: "SAME_DAY",
          hour: 23,
          minute: 59,
        },
      }
    } else {
      return existingClassSetting
    }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::GoogleClassroom::Parts::FindOrCreateClassSetting": typeof GoogleClassroomFindClassSetting
  }
}
